import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/shared/hooks/useAuth";
import { useIsLawyer } from "@/shared/hooks/useIsLawyer";
import { useAuthRouter } from "@/shared/hooks/useAuthRouter";
import CircularProgress from "@/shared/components/CircularProgress";
import FullscreenLayout from "@/pages/layouts/FullScreenLayout";
import { AUTH_ROUTES, LAWYER_ROUTES, ONBOARDING_ROUTES } from "@/shared/constants/paths";

export function ProtectedRouteWrapper() {
  const { user: authUser, loading: isLoading } = useAuth();
  const { isLawyer, isLoading: lawyerLoading } = useIsLawyer();
  const { destination, isLoading: authRouterLoading } = useAuthRouter();
  const location = useLocation();

  if (isLoading || lawyerLoading || authRouterLoading) {
    return (
      <FullscreenLayout>
        <CircularProgress />
      </FullscreenLayout>
    );
  }

  if (!authUser) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`${AUTH_ROUTES.SIGN_IN}?returnTo=${returnTo}`} replace />;
  }

  if (isLawyer) {
    return <Navigate to={LAWYER_ROUTES.DASHBOARD} replace />;
  }

  if (destination.type === "onboarding") {
    return <Navigate to={ONBOARDING_ROUTES.ACCOUNT} replace />;
  }

  return <Outlet />;
}
